export enum TFrequencies {
  Annual = "annual",
  Biannual = "biannual",
  Quarter = "quarter",
  Month = "month",
  Week = "week",
  Day = "day",
}
